import React from "react";
import { FaYoutube, FaExternalLinkAlt } from "react-icons/fa";
import EmotionalJournal from "./EmotionalJournal"; // <-- Import the journal
import { useAuth } from "../contexts/GoogleAuthContext"; // <-- To pass the userId

export default function Mindset() {
  const { user } = useAuth(); // Get the logged-in user

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors py-10 px-4">
      <div className="max-w-6xl mx-auto space-y-12"> {/* Widened max-w to fit the calendar nicely */}
        
        {/* Page Header */}
        <header className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-blue-900 dark:text-blue-200">
            Mindset & Psychology
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            Condition your mental framework for compound growth and emotional discipline.
          </p>
        </header>

        {/* Mindset Video of the Week Section */}
        <section className="space-y-6 max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 border-b pb-2 border-gray-200 dark:border-gray-700">
            Mindset Video of the Week
          </h2>
          
          <div className="flex justify-center">
            <div className="w-full md:max-w-lg">
              <VideoCard
                title="The Hidden Power of Patience in Trading Psychology"
                author="Psychology of Profit"
                videoId="rSVPYGqYQwY"
              />
            </div>
          </div>
        </section>

        {/* ========================================= */}
        {/* NEW: Insert the Emotional Journal Component */}
        {/* ========================================= */}
        <section className="border-t border-gray-200 dark:border-gray-800 pt-12">
          {user?.uid ? (
            <EmotionalJournal userId={user.uid} hideHeader={true} /> 
          ) : (
            <div className="text-center text-gray-500 py-10">Loading journal...</div>
          )}
        </section>




        {/* Mindset Audiobooks Section */}
        <section className="space-y-6">
          <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 border-b pb-2 border-gray-200 dark:border-gray-700">
            Mindset Audiobooks
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <VideoCard
              title="Trading In The Zone"
              author="Mark Douglas"
              videoId="tMRtojrPggY"
            />
             <VideoCard
              title="The Mental Game of Trading"
              author="Jared Tendler"
              videoId="961HKZeYkkg"
            />
            <VideoCard
              title="The Compound Effect"
              author="Darren Hardy"
              videoId="cu0BiB6UCzQ"
            />
          </div>
        </section>
      </div>
    </div>
  );
}

function VideoCard({ title, author, videoId }) {
  const url = `https://www.youtube.com/watch?v=${videoId}`;
  
  // Use mqdefault.jpg to ensure a thumbnail always loads without the grey 3-dot placeholder
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;

  return (
    <div className="flex flex-col bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-lg border border-gray-200 dark:border-gray-700 transition-all hover:shadow-xl h-full">
      <a 
        href={url} 
        target="_blank" 
        rel="noopener noreferrer" 
        title="Opens YouTube in a new tab"
        className="relative group block aspect-video overflow-hidden bg-gray-200 dark:bg-gray-900 shrink-0"
      >
        <img 
          src={thumbnailUrl} 
          alt={`Thumbnail for ${title}`} 
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" 
        />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <FaYoutube className="text-red-600 text-6xl drop-shadow-lg" />
        </div>
      </a>
      
      <div className="p-6 flex flex-col flex-1">
        <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 leading-tight mb-1">
          {title}
        </h3>
        <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-6">
          By {author}
        </p>
        
        <div className="mt-auto space-y-4">
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title="Opens YouTube in a new tab"
            className="flex items-center justify-center w-full gap-2 bg-[#ff0000] hover:bg-[#cc0000] text-white text-sm font-bold py-3 px-4 rounded-lg transition-colors shadow-sm"
          >
            <FaYoutube size={20} />
            Watch on YouTube
            <FaExternalLinkAlt size={12} className="ml-1 opacity-80" />
          </a>
          
          <p className="text-[11px] text-gray-400 dark:text-gray-500 text-center leading-relaxed">
            Third-party content hosted on YouTube. Trapound does not own or host this recording.
          </p>
        </div>
      </div>
    </div>
  );
}